import { TbSearch } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const SearchIcon = (props: IconProps) => {
  return <IconBase icon={TbSearch} {...props} />;
};
